import { isEmpty } from "lodash";
import AppContext from "PFApp/app_context";
import FiltersBox from "PFApp/components/filters/filters_box";
import FiltersButton from "PFApp/components/filters/filters_button";
import FiltersPreview from "PFApp/components/filters/filters_preview";
import {
  checkFiltersAreClear,
  filterElements,
  getAPIFilters,
  getValueFilters
} from "PFApp/use_filtered_collection";
import TableProperties from "PFApp/workflow/parts/table_properties";
import TablePropertiesButton from "PFApp/workflow/parts/table_properties_button";
import { useDeterministicStringify } from "PFCore/helpers/use_deterministic_stringity";
import React, { useContext, useMemo, useState } from "react";

import css from "./controls.module.scss";
import { defaultColumns } from "./use_approvals_tab";

const ApprovalsControls = () => {
  const {
    store: {
      pages: {
        booking: { approvals }
      }
    }
  } = useContext(AppContext);

  const { data, loaded, loading, onFiltersChange, onFiltersReset, columns, setColumns } = approvals || {};
  const { meta } = data || {};

  const stringify = useDeterministicStringify();
  const [showFilters, setShowFilters] = useState(false);
  const [showTableProperties, setShowTableProperties] = useState(false);

  const toggleTableProperties = () => setShowTableProperties((prev) => !prev);

  const noFiltersSelected = useMemo(
    () => isEmpty(meta) || checkFiltersAreClear(meta.filters, ["state"]),
    [meta]
  );
  const showFiltersButton = useMemo(() => !isEmpty(meta) && filterElements(meta.filters).length > 0, [meta]);

  return (
    <>
      <div className={css.controls}>
        <TablePropertiesButton isActive={showTableProperties} onClick={toggleTableProperties} />
        {showFiltersButton && (
          <FiltersButton
            style={{ marginLeft: 20 }}
            filtersAreClear={noFiltersSelected}
            onClick={() => setShowFilters((prev) => !prev)}
            qaId="BookingApprovalsFilterButton"
          />
        )}
      </div>
      {!!loaded && (
        <TableProperties
          isVisible={showTableProperties}
          onCloseClick={toggleTableProperties}
          selectedColumns={columns}
          onColumnsChange={setColumns}
          defaultColumns={defaultColumns}
        />
      )}
      {showFilters && (
        <div className={css.filters}>
          <FiltersBox
            style={{ position: "relative", width: "100%" }}
            isLoading={loading}
            meta={meta}
            handleFilterChange={onFiltersChange}
            clearFilters={() => onFiltersReset()}
            filtersAreClear={noFiltersSelected}
            closeFilters={() => setShowFilters(false)}
            clearRefValue={stringify(getAPIFilters(getValueFilters(meta.filters)))}
            allowToClose
          />
        </div>
      )}
      {!!loaded && (
        <div className={css.preview}>
          <FiltersPreview
            meta={meta}
            filtersAreClear={noFiltersSelected}
            clearFilters={() => onFiltersReset()}
            onFilterChange={onFiltersChange}
            onMoreClicked={() => setShowFilters(true)}
            reserveSpace
          />
        </div>
      )}
    </>
  );
};

export default ApprovalsControls;
